import { faWarning } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import * as React from 'react';
import { Dispatch, SetStateAction } from 'react';
import { formatNumber } from '../../../logic/otherUtilities/formatting/formatNumber';
import VoxelCheckbox from '../Forms/VoxelCheckbox';
import VoxelText from '../Text/VoxelText';

export interface RankOptionProps {
  title: string;
  selectedOption: boolean;
  setSelectedOption: Dispatch<SetStateAction<boolean>>;
  optionKeywordCount: number;
  dateList?: string[];
  disabled?: boolean;
  warningText?: string;
}

const RankOption: React.FC<RankOptionProps> = ({
  title,
  dateList,
  selectedOption,
  setSelectedOption,
  optionKeywordCount,
  disabled,
  warningText,
}) => {
  // Update rank dates
  const firstDate = dateList?.length > 1 ? moment(dateList[0]).local().format('YYYY-MM-DD') : null;
  const secondDate = dateList?.length > 2 ? moment(dateList[1]).local().format('YYYY-MM-DD') : null;

  const rankDateString =
    firstDate && secondDate ? firstDate + ' - ' + secondDate : firstDate ? firstDate : 'none';

  return (
    <div>
      <div
        className={` w-full flex flex-row gap-0 items-start ${disabled ? '' : 'cursor-pointer'}`}
        onClick={() => setSelectedOption(optionKeywordCount > 0 ? !selectedOption : selectedOption)}
      >
        <div className="mx-4 ">
          <VoxelCheckbox
            color="primary"
            shape="square"
            checked={selectedOption}
            disabled={disabled}
            padding
            onChange={() =>
              setSelectedOption(optionKeywordCount > 0 ? !selectedOption : selectedOption)
            }
          />
        </div>
        <div className="flex flex-col gap-0.5">
          <VoxelText
            className="!select-none"
            variant="title3"
            color={disabled ? 'slight' : selectedOption ? 'dark' : 'light'}
          >
            {title}
          </VoxelText>
          <VoxelText
            variant="bread-normal"
            color={disabled ? 'slight' : selectedOption ? 'dark' : 'light'}
          >
            <span className="font-medium">{formatNumber(optionKeywordCount)}</span> keywords
            {!!dateList?.length && !!optionKeywordCount && (
              <span>, last rank retrieval: {rankDateString}</span>
            )}
          </VoxelText>
        </div>
      </div>
      {!!warningText && (
        <div className=" bg-voxel-orange-100 rounded-b-md p-2 text-voxel-orange-700 flex flex-row  items-center gap-3">
          <FontAwesomeIcon icon={faWarning} size="lg" className="text-voxel-orange-700" />
          <VoxelText colorClassName="text-voxel-orange-700" variant="form-caption">
            {warningText}
          </VoxelText>
        </div>
      )}
    </div>
  );
};

export default RankOption;
